import { createAction } from 'redux-actions';
import { getInternalReferenceByRevisionAndElementId } from 'api/internal-reference-api';

//duplicate: To avoid circular dependency
const setInternalReferenceLoading = createAction('INTERNAL_REFERENCE_LOADING');
const setInternalReferenceLoaded = createAction('INTERNAL_REFERENCE_LOADED');
const setInternalReferenceError = createAction('INTERNAL_REFERENCE_ERROR');

export const getInternalReferenceWithoutLoading =
  () => async (dispatch, getState) => {
    try {
      const { elementDetails } = getState().data.elementPanel;
      const response = await getInternalReferenceByRevisionAndElementId({
        revisionId: elementDetails.revisionId,
        elementId: elementDetails.id,
      });
      dispatch(setInternalReferenceLoaded({ response }));
    } catch (error) {
      dispatch(setInternalReferenceError(error));
    }
  };

export const getElementInternalReference = () => async (dispatch, getState) => {
  dispatch(setInternalReferenceLoading());
  dispatch(getInternalReferenceWithoutLoading());
};
